import { Component, ViewChild } from '@angular/core';
import { Content, ModalController, NavParams } from 'ionic-angular';
import { Subject } from 'rxjs';

import { DirectionsService } from '../../providers/directions/directions';
import { LoadingAlertProvider } from './../../providers/loading-alert/loading-alert';
import { NoteCreateParams, NoteModel } from './../../models/note';
import { OpsOrderModel } from '../../models/order.ops';
import { OpsProvider } from '../../providers/ops/ops';
import { OrderAddNotePage } from '../order-add-note/order-add-note';


@Component({
  selector: 'page-order-notes',
  templateUrl: 'order-notes.html',
})
export class OrderNotesPage {
  @ViewChild('notesContent') content: Content;

  order: OpsOrderModel;
  notes: NoteModel[];
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    navParams: NavParams,
    private modalCtlr: ModalController,
    private opsService: OpsProvider,
    private loadingAlert: LoadingAlertProvider,
    private directions: DirectionsService
  ) {
    this.order = navParams.get('order');
    this.notes = navParams.get('notes');
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // Actions

  didTapAddNote() {
    let modal = this.modalCtlr.create(OrderAddNotePage);
    modal.onDidDismiss(data => {
      if (data) {
        this.saveNote(data);
      }
    });
    modal.present();
  }

  didTapNote(note: NoteModel) {
    if (note.url) {
      this.openUrl(note.url);
    } else if (note.lat && note.lng) {
      this.directions.get(note.lat, note.lng);
    }
  }

  private openUrl(url: string) {
    window.open(url, '_blank');
  }

  // Data

  saveNote(params: NoteCreateParams) {
    if (!params) {
      return;
    }

    this.loadingAlert.showLoader();
    this.opsService
      .addNoteForCustomer(this.order.user.uid, params)
      .finally(() => this.loadingAlert.dismissLoader())
      .subscribe(
        note => this.notes.unshift(note),
        error => this.loadingAlert.showToastAlert('Error saving note')
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-notes/order-notes.ts